export default function PHP_Variables_Scope() {
  return (
    <div>
      <h1>PHP_Variables_Scope</h1>
    </div>
  );
}
